module.exports = __webpack_public_path__ + "static/media/app-store.080ab981.svg";